import React, { Component } from "react";
import {
  Menu,
  Dropdown,
  Card,
  Skeleton,
  Pagination,
  message,
  Result,
  Button,
} from "antd";
import TabHeader from "./TabHeader";
import {
  FaEllipsisH,
  FaEye,
  FaTrashAlt,
  FaArrowRight,
  FaArrowLeft,
  FaInfo,
  FaCheck,
  FaPlus,
} from "react-icons/fa";
import "./TabHeader.scss";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import FilterModal from "../FilterModal/FilterModal";
import DeleteModal from "../DeleteModal/DeleteModal";
import { Link } from "react-router-dom";
import { GetAllFinancingRequests } from "../../network/request.network";
import moment from "moment";
import {
  DeleteOrder,
  UpdateFinancingRequestGeneralStatus,
} from "../../network/customer.network";

const { Meta } = Card;

class ContactTab extends Component {
  state = {
    financingList: [],
    loading: true,
    showFilter: false,
    addAdmin: false,
    showDltModal: false,
    accountable: null,
    filterData: null,
    searchword: null,
    orderInfo: null,
    selectedRowKeys: [],
    allData: {},
    activeOrderTab: "order",
    docCompelete: false,
    pageCurrent: 0,
  };

  handleDeleteCharge = (id) => {
    this.setState({ showDltModal: true });
  };

  closeDltModal = () => {
    this.setState({ showDltModal: false });
  };

  componentDidMount() {
    const { showType } = this.props;
    this.setState({ activeOrderTab: showType });
    this.handelGetFRList();
  }

  handelGetFRList = (Page = 0) => {
    // const page =  Page === 0 ? 0 : Page+1
    // console.log(page, "Page")
    const { showType, searchAll } = this.props;
    const { filterData, searchword } = this.state;
    this.setState({ loading: true, pageCurrent: 0 });
    let body = {
      Page,
    };
    if (filterData) {
      body = {
        ...body,
        ...filterData,
      };
    }
    if (searchword) {
      body = {
        ...body,
        searchword,
      };
    }
    if (searchAll) {
      body = {
        ...body,
        searchword: +searchAll,
      };
    }
    body.FinanceRequestStatusId = 0;

    GetAllFinancingRequests(
      body,
      (res) => {
        this.setState({ loading: false, allData: res.data.model });
        this.setState({
          financingList: res.data.model,
          totalordersCount: res.data.metas?.totalCount || 0,
        });
      },
      () => {
        this.setState({ loading: false });
      }
    );
  };

  itemRender = (current, type, originalElement) => {
    if (type === "prev") {
      return (
        <a className="prev-page-btn pagin-page-btn">
          <FaArrowRight /> الصفحة السابقة{" "}
        </a>
      );
    }
    if (type === "next") {
      return (
        <a className="next-page-btn pagin-page-btn">
          الصفحة التاليه <FaArrowLeft />{" "}
        </a>
      );
    }
    return originalElement;
  };

  handelShowFilter = () => {
    this.setState({ showFilter: true });
  };

  handelShowAdmin = () => {
    this.setState({ addAdmin: true });
  };

  handelCloseFilter = () => {
    this.setState({ showFilter: false });
  };

  handelFilterTab = (filter) => {
    //console.log(filter)
    this.setState({ showFilter: false, filterData: filter }, () => {
      this.handelGetFRList();
    });
  };

  onSearchUSerOrder = (val) => {
    this.setState({ searchword: val }, () => {
      this.handelGetFRList();
    });
  };

  handlOrderStatuse = (statuses, FinanceRequestStatus) => {
    if (
      statuses?.FinancingRequestGeneralStatusId === 11 ||
      statuses?.FinancingRequestGeneralStatusId === 3 ||
      statuses?.FinancingRequestGeneralStatusId === 22
    ) {
      return (
        <>
          <div className="doc-state">
            <div className="btn-circle missing">
              <div className="icon-holder">
                <FaInfo />
              </div>
            </div>
            <div className="info-divider"></div>
          </div>
          <div className="doc-state--result">
            <p>{statuses?.FinancingRequestGeneralStatus?.NameLT}</p>
          </div>
        </>
      );
    } else {
      return (
        <>
          <div className={`doc-state`}>
            <div className="btn-circle compeleted">
              <div className="icon-holder">
                <FaCheck />
              </div>
            </div>
            <div className="info-divider"></div>
          </div>
          <div className="doc-state--result">
            <p>
              {FinanceRequestStatus?.NameLT ||
                "تم ارسال الطلب وجاري العمل عليه"}
            </p>
          </div>
        </>
      );
    }
  };

  handeldeleteOrder = () => {
    this.setState({ tableLoading: true });
    const { orderInfo } = this.state;
    DeleteOrder(
      orderInfo?.Id,
      (res) => {
        message.success("تم حذف الطلب بنجاح");
        UpdateFinancingRequestGeneralStatus(
          orderInfo?.Id,
          22,
          (res) => {
            this.handelGetFRList();
          },
          (err) => {}
        );
      },
      (error) => {
        this.setState({ tableLoading: false });
      }
    );
  };

  render() {
    const {
      loading,
      showFilter,
      financingList,
      pageCurrent,
      showDltModal,
      totalordersCount,
    } = this.state;
    const { title, showType } = this.props;
    // const rowSelection = {
    //   selectedRowKeys,
    //   columnTitle : "اجراءت",
    //   columnWidth : 120,
    //   onChange: this.onSelectChange,
    // };
    // const hasSelected = selectedRowKeys.length > 0;

    return (
      <div className="contact-tab-wrapper order-tab-holder">
        <TabHeader
          showType={showType}
          handelShowFilter={this.handelShowFilter}
          title={title}
          handelShowAdmin={this.handelShowAdmin}
          onSearchUSerOrder={this.onSearchUSerOrder}
        />

        {showDltModal && (
          <DeleteModal
            delete={this.handeldeleteOrder}
            name="الطلب"
            closeDltModal={this.closeDltModal}
          />
        )}

        {showFilter && (
          <FilterModal
            handelCloseFilter={this.handelCloseFilter}
            handelFilterTab={this.handelFilterTab}
          />
        )}

        {/* <Spin spinning={loading}> */}

        <div className="orders-content-wrapper cards-list-wrapper">
          {loading ? (
            [0, 1, 2, 3, 4, 5].map((skl) => (
              <Skeleton key={skl} active avatar paragraph={{ rows: 4 }} />
            ))
          ) : financingList.length === 0 ? (
            <Result
              status="404"
              title=""
              subTitle="عذرا ، لم يتم العثور على طلب يمكنك إضافة طلب الآن"
              extra={
                <Button
                  type="primary"
                  size="large"
                  className="blue-btn new-order-btn"
                >
                  <Link to="/cars">
                    <FaPlus />
                    طلب جديد
                  </Link>
                </Button>
              }
            />
          ) : (
            financingList.map((order) => (
              <div key={order.Id}>
                <Card
                  className="card-view-holder"
                  onClick={() =>
                    this.props.history.push({
                      pathname: "/client",
                      state: { orderId: order.Id },
                    })
                  }
                >
                  <Meta
                    description={
                      <div className="orders-holder">
                        <div className="order-desc">
                          <p>رقم الطلب</p>
                          <h6>{order.Id}</h6>
                          <div className="time-holder">
                            <p>تاريخ الإنشاء</p> &nbsp;
                            <p>
                              {moment
                                .utc(order?.CreationDate)
                                .local()
                                .format("YYYY/M/D - HH:MM")}
                            </p>
                          </div>
                        </div>

                        <div className="orders-actions">
                          <div className="action-dropdown-holder">
                            <Dropdown
                              overlayClassName="action-dropdown-holder"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                              }}
                              trigger={["click"]}
                              overlay={
                                <Menu
                                  onClick={(Item) => {
                                    Item.domEvent.stopPropagation();
                                  }}
                                >
                                  <Menu.Item
                                    className="show-item"
                                    icon={<FaEye />}
                                  >
                                    <Link
                                      to={{
                                        pathname: "/client",
                                        state: { orderId: order.Id },
                                      }}
                                    >
                                      عرض
                                    </Link>
                                  </Menu.Item>

                                  {/* <Menu.Item
                                      className="remove-item"
                                      icon={<FaTrashAlt />}
                                      onClick={() => {
                                        this.setState({showDltModal : true, orderInfo: order})
                                      }}
                                    >
                                      <p>الغاء الطلب </p>
                                    </Menu.Item> */}
                                </Menu>
                              }
                              placement="bottomLeft"
                            >
                              <div className="dropdown-icon-holder">
                                <FaEllipsisH />
                              </div>
                            </Dropdown>
                          </div>
                          {/* {order?.FinanceRequestStatus?.NameLT} */}
                          {this.handlOrderStatuse(
                            order?.FinancingRequestGeneralStatusLog,
                            order?.FinanceRequestStatus
                          )}
                        </div>
                      </div>
                    }
                  />
                </Card>
              </div>
            ))
          )}
        </div>
        {financingList.length > 0 && (
          <div className="pagination-card-holder">
            <Pagination
              simple
              itemRender={this.itemRender}
              onChange={this.handelGetFRList}
              pageSize={30}
              total={totalordersCount}
              // current={pageCurrent}
              // defaultCurrent={1}
            />
          </div>
        )}

        {/* </Spin> */}
      </div>
    );
  }
}

const ContactTabWithRouter = withRouter(ContactTab);
export default connect()(ContactTabWithRouter);
